import { Stack } from "expo-router";
import { useTheme } from "@/hooks/useTheme";
import Head from "expo-router/head";

export default function SignUpLayout() {
  const { colors } = useTheme();

  return (
    <>
      <Head>
        <title>RockForce Sign-up</title>
        <meta name="description" content="" />
      </Head>
      <Stack
        screenOptions={{
          animation: "simple_push",
          headerShown: false,
          contentStyle: { backgroundColor: colors.background },
        }}
      >
        <Stack.Screen name="invite" />
        <Stack.Screen name="[session]" />
      </Stack>
    </>
  );
}
